<template>
  <div>
    <h3 class="h-title">提交文件-拟存储文件</h3> 
    <el-form class="e-form f-b" ref="cForm" :model="cForm" label-width="100px"  label-position="left" :rules="setpFormRules5">
        <el-form-item class="w-70" label="拟存储文件" prop="planSaveFileList">
        <el-upload
            class="upload-part"
            :limit="1"
            :action="action"
            :headers = "headers"
            :before-upload="(file) => beforeUpload(file)"
            :on-remove="(file, fileList) => handleRemove(file, fileList, 'planSaveFileList')"
            :on-success="(response, file, fileList) => upload(response, file, fileList, 'planSaveFileList')" 
            :on-error="handleError"
            :file-list="cForm.planSaveFileList || []">
            <el-button size="small" type="orange">上传</el-button>
        </el-upload>
        <div class="el-form-item__error" v-show="isFile">
          请上传
        </div>
      </el-form-item> 
    </el-form>
    <div class="cenrer">			
      <el-button class="s-but" type="orange" @click.native="prev">上一步</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('0')" :loading="butLoading">保 存</el-button>
      <el-button class="s-but" type="orange" @click="cSubmitForm('1')" :loading="butLoading">提 交</el-button>
    </div>
  </div>
</template>

<script>
import baseUrl from '@/api/baseUrl.js'
export default {
  name: "step5",
  props: ["active"],
  data() {
    return {
      headers: {
        Authorization: "Bearer " + sessionStorage.getItem("token")
      },
      action: '',
      butLoading: false,
      cForm: {},
      setpFormRules5: {
        planSaveFileList: [
            { type: 'array', required: true, message: '请上传', trigger: 'change' }
        ]
      },
      isFile: false
    }
  },
  watch: {
      active(newVal) {
        if(newVal == 5) {
          window.scrollTo(0,0);
          this.action = `${baseUrl.iaccUrl}/iacc-contract-platform/common/uploadFile`;
          // this.action = `http://172.30.15.232:9097/common/uploadFile`;
          this.cForm = JSON.parse(sessionStorage.setpForm);
          this.cForm.planSaveFileList = JSON.parse(this.cForm.planSaveFile || '[]');
        } 
      }
    },
  methods: {  
    prev() {
      this.cForm.planSaveFile = JSON.stringify(this.cForm.planSaveFileList||[]);
      sessionStorage.setpForm = JSON.stringify(this.cForm);
      this.$emit('prev')
    },
    cSubmitForm(status){
      if(status == '0'){
        this.butLoading = true;
        this.cForm.status = status
        this.cForm.planSaveFile = JSON.stringify(this.cForm.planSaveFileList||[]);

        this.$api.api.saveContract(JSON.stringify(this.cForm)).then(response => {
          this.butLoading = false;
          if(response.code == 200){
            sessionStorage.removeItem("setpForm")
            this.$message.success("保存成功");
            this.$router.go(-1);
          }else {
            this.$message.error(response.msg);
          }      
        });
      }else {
        if (this.cForm.planSaveFileList.length > 0) {
          this.butLoading = true;
          this.cForm.status = status
          this.cForm.planSaveFile = JSON.stringify(this.cForm.planSaveFileList||[]);

          this.$api.api.saveContract(JSON.stringify(this.cForm)).then(response => {
            this.butLoading = false;
            if(response.code == 200){
              sessionStorage.removeItem("setpForm")
              this.$message.success("提交成功");
              this.$router.go(-1);
            }else {
              this.$message.error(response.msg);
            }      
          });
        
        }else {
          this.isFile = true
        }
      } 
    },
    handleError(err, file, fileList){
        this.$message.error(file.name + "文件上传失败");
      },
      beforeUpload(file) { 	
        const isLt2M = file.size / 1024 / 1024 <= 80     //这里做文件大小限制
        
        if(!isLt2M) {
          this.$message.error('上传文件大小不能超过 80MB！');
        }
        return isLt2M
      },
      upload(response, file, list, name){
          if(response.code == 200){
            this.$set(this.cForm, name, [{
              name: response.name,
              url: response.url
            }])
            this.isFile = false
          }else{
            this.$set(this.cForm, name,[])
            this.isFile = true
            if(response.msg){
              this.$message.error(response.msg);
            }else {
              this.$message.error(file.name + "文件上传失败");
            }							
          }            
      },
      handleRemove(file, fileList, name) {
        this.$set(this.cForm, name, [])

      },
  }
}
</script>
